import React, { useState, useEffect } from 'react';
import { WifiIcon, SignalSlashIcon } from '@heroicons/react/24/outline';

const NetworkStatusIndicator: React.FC = () => {
  const [isOnline, setIsOnline] = useState(navigator.onLine);

  useEffect(() => {
    const handleOnline = () => setIsOnline(true);
    const handleOffline = () => setIsOnline(false);

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []);

  if (isOnline) {
    return null; // Don't show anything if online
  }

  return (
    <div className="fixed bottom-4 right-4 z-50 p-3 bg-red-600 text-white rounded-full shadow-lg flex items-center space-x-2 animate-bounce">
      <SignalSlashIcon className="h-6 w-6" />
      <span className="font-medium">Offline Mode</span>
    </div>
  );
};

export default NetworkStatusIndicator;
